import React from "react";
import clsx from "clsx";

import { htmlSafe } from "modules/utils";

import WarningSVG from "modules/theme/icons/general/warning.svg";

import * as styles from "./styles.module.scss";

type NoResultsMessageProps = {
  errorMessage?: string | null;
  largeContainer?: boolean;
  noContainer?: boolean;
};

const NoResultsMessage: React.FC<NoResultsMessageProps> = ({ errorMessage, largeContainer, noContainer }) => {
  const containerClassName = clsx("container", largeContainer ? "" : "small");
  return noContainer ? (
    <div className={clsx(styles.noResults, noContainer && styles.noContainer)}>
      <WarningSVG />
      {errorMessage && <h2>{htmlSafe(errorMessage.toString())}</h2>}
    </div>
  ) : (
    <div className={styles.noResults}>
      <div className={containerClassName}>
        <div>
          <WarningSVG />
          {errorMessage && <h2>{htmlSafe(errorMessage.toString())}</h2>}
        </div>
      </div>
    </div>
  );
};

export default NoResultsMessage;
